import { Injectable, inject } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { IdValuePair } from "@tylertech/tyler-api-types";
import { ServiceAddressRevenueInfo, UBAddAccountWizardMessage } from "../interfaces";
@Injectable()
export class AddAccountWizardService
{
    private readonly $apiService = inject(ApiService);


    getAddAccountWizardMessagesForContact(contactId: string): Promise<UBAddAccountWizardMessage[]>
    {
        return this.$apiService.sendAuth("IAddAccountWizardService/GetAddAccountWizardMessagesForContact", contactId);
    }

    getAddAccountWizardMessagesForServiceAddress(serviceAddressId: string): Promise<UBAddAccountWizardMessage[]>
    {
        return this.$apiService.sendAuth(
            "IAddAccountWizardService/GetAddAccountWizardMessagesForServiceAddress",
            serviceAddressId
        );
    }

    getDefaultAccountClassCode(serviceAddressId: string): Promise<IdValuePair>
    {
        return this.$apiService.sendAuth("IAddAccountWizardService/GetDefaultAccountClassCode", serviceAddressId);
    }

    getRevenueCodeBalancesByServiceAddress(serviceAddressId: string): Promise<ServiceAddressRevenueInfo[]>
    {
        return this.$apiService.sendAuth(
            "IAddAccountWizardService/GetRevenueCodeBalancesByServiceAddress",
            serviceAddressId
        );
    }

    getUbContactSet(): Promise<string>
    {
        return this.$apiService.sendAuth("IAddAccountWizardService/GetUbContactSet");
    }

    hasOnlineUtilityExchange(): Promise<boolean>
    {
        return this.$apiService.sendAuth("IAddAccountWizardService/HasOnlineUtilityExchange");
    }
}
